<template>
  <div class="container-fluid">
    <h3 v-if="loadedSchema">
      Carregando...
    </h3>
    
    <div class="row" v-else-if="schema">
      <div class="col-md-12">
        <div class="form-group">
          <label for="schema-name">Nome</label>
          <input v-model="schema.name" id="schema-name" class="form-control" :disabled="createdLayout">
        </div>
        
        <div class="form-group">
          <label for="schema-description" class="mr-2">Descrição</label>
          <textarea v-model="schema.description" id="schema-description" class="form-control" :disabled="createdLayout"/>
        </div>
        
        <div class="form-group">
          <label for="schema-public" class="mr-2">Público</label>
          <input v-model="schema.public" id="schema-public" type="checkbox" :disabled="createdLayout">
        </div>
        
        <div class="form-group" v-if="createdLayout">
          <label for="schema-created-by" class="mr-2">Criado por</label>
          <input :value="schema.createdBy" id="schema-created-by" class="form-control" disabled="disabled">
        </div>
        
        <div class="ibox">
          <div class="ibox-title">
            <span>Colunas</span>
            <button v-if="!createdLayout" class="btn btn-outline float-right" @click="addColumn">
              Adicionar
            </button>
          </div>
          
          <div class="ibox-content">
            <table class="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th>Tipo</th>
                  <th>Valor padrão</th>
                  <th>Obrigatório</th>
                  <th>Exemplo</th>
                  <th v-if="!createdLayout"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(column, index) in schema.columns" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ column.name }}</td>
                  <td>{{ column.description }}</td>
                  <td>{{ column.type }}</td>
                  <td>{{ column.default }}</td>
                  <td>{{ column.required ? 'Sim' : 'Não' }}</td>
                  <td :title="column.title">
                    <input v-if="['string', 'number'].includes(column.type)" :type="column.type" class="form-control">
    
                    <select v-else-if="column.type === 'select'" class="form-control">
                      <option :value="options[1]" v-for="(options, index) in column.options" :key="index">
                        {{ options[0] }}
                      </option>
                    </select>
                  </td>
                  <td v-if="!createdLayout">
                    <button @click="move(index, index - 1)" class="btn btn-outline mr-1"
                            :disabled="index === 0">para cima</button>
                    <button @click="move(index, index + 1)" class="btn btn-outline mr-1"
                            :disabled="index + 1 === schema.columns.length">para baixo</button>
  
                    <button class="btn btn-outline mr-3" @click="editColumn(column)">
                      Editar
                    </button>
                    <button class="btn btn-outline" @click="removeColumn(index)">
                      Remover
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
        
        <div class="form-group mt-3" v-if="createdLayout">
          <button @click="showNewTabledModal=true" class="btn btn-primary px-4" style="width: 100%">
            Usar layout
          </button>
        </div>
        
        <div class="form-group mt-3" v-else>
          <button class="btn btn-outline mr-3 px-4" @click="$router.back()">
            Cancelar
          </button>
          
          <button @click="save" class="btn btn-primary px-4">
            Salvar
          </button>
        </div>
        
      </div>
    </div>
  
    <Field v-model="showFieldModal" :field="currentHeader"/>
    
    <NewTable v-if="schema" v-model="showNewTabledModal" :schema="schema"/>
  </div>
</template>

<script>
import Field from '@/components/custom_table/schema/Field'
import ModelMapper from '@/mixins/ModelMapper'
import NewTable from '@/components/custom_table/table/NewTable'
import { mapMutations } from 'vuex'

export default {
  activated() {
    this.loadSchema()
  },
  components: { Field, NewTable },
  computed: {
    createdLayout() {
      return this.schema.id
    }
  },
  data: ()=> ({
    currentHeader: {},
    loadedSchema: true,
    modelPathPrefix: 'custom_table',
    nameModel: 'Schema',
    schema: null,
    showFieldModal: false,
    showNewTabledModal: false,
    types: [
      ['texto', 'string'],
      ['númerico', 'number'],
      ['seleção', 'select'],
    ]
  }),
  deactivated() {
    this.schema = null
    this.setNameBreadcrumb('...')
  },
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    addColumn() {
      const column = {}
      this.currentHeader = column
      this.schema.columns.push(column)
      this.showFieldModal = true
    },
    buildData() {
      return { ...this.schema }
    },
    buildPath() {
      return 'custom_table/schemas'
    },
    editColumn(column) {
      this.currentHeader = column
      this.showFieldModal = true
    },
    loadNewSchema() {
      this.schema = { columns: [], public: false }
      this.loadedSchema = false
      this.setBreadcrumb()
    },
    loadSchema() {
      if (this.id === 'new')
        return this.loadNewSchema()
  
      this.asyncTemplateShow(this.id, {
        after: ({model}) => this.schema = model,
        finish: () => {
          this.loadedSchema = false
          this.setBreadcrumb()
        }
      })
    },
    move(to, from) {
      if (from < 0 || from === this.schema.columns.length)
        return
    
      const toRow = this.schema.columns[to]
      const toFrom = this.schema.columns[from]
      this.$set(this.schema.columns, from, toRow)
      this.$set(this.schema.columns, to, toFrom)
    },
    removeColumn(index) {
      this.schema.columns.splice(index, 1)
    },
    save() {
      this.asyncTemplateSave(this.schema, {
        after: ({model}) => this.schema = model,
        finish: () => this.setNameBreadcrumb(this.schema.name)
      })
    },
    setBreadcrumb() {
      if (this.id === 'new')
        this.setNameBreadcrumb('Novo')
      else
        this.setNameBreadcrumb(this.schema && this.schema.name)
    }
  },
  mixins: [ModelMapper],
  name: 'Form',
  props: ['id']
}
</script>

<style scoped>

*:disabled {
  cursor: not-allowed;
}
</style>